/* ==========================================================================
   ARKHELAIS FISHING (US) — Dönüşüm Teması / theme.js
   Bağımlılık yok. Tüm modüller kendi elemanları sayfada yoksa sessizce çıkar.
   ========================================================================== */
(function () {
  'use strict';

  var T = window.ArkhelaisTheme || {};
  T.routes = T.routes || {};

  /* ------------------------------------------------------------ yardımcılar */

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }
  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }
  function on(el, evt, fn, opts) {
    if (el) el.addEventListener(evt, fn, opts);
  }

  function parseJSON(str, fallback) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return fallback;
    }
  }

  /**
   * Shopify money_format desenini uygular.
   * Desteklenen: amount, amount_no_decimals, amount_with_comma_separator,
   * amount_no_decimals_with_comma_separator, amount_with_apostrophe_separator
   */
  function formatMoney(cents, format) {
    var fmt = format || T.moneyFormat || '{{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = fmt.match(placeholder);
    var name = match ? match[1] : 'amount';

    function pad(num, size) {
      var s = String(num);
      while (s.length < size) s = '0' + s;
      return s;
    }

    function build(precision, thousands, decimal) {
      var num = (cents / 100.0).toFixed(precision);
      var parts = num.split('.');
      var intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var decPart = parts[1] ? decimal + pad(parts[1], precision) : '';
      return intPart + decPart;
    }

    switch (name) {
      case 'amount':
        value = build(2, ',', '.');
        break;
      case 'amount_no_decimals':
        value = build(0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = build(2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = build(0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = build(2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = build(0, ' ', ',');
        break;
      case 'amount_with_space_separator':
        value = build(2, ' ', ',');
        break;
      default:
        value = build(2, ',', '.');
    }
    return fmt.replace(placeholder, value);
  }

  /** Metni yazar; gerçekten değiştiyse kısa bir vurgu animasyonu tetikler. */
  function setText(el, value) {
    if (!el || el.textContent === value) return;
    el.textContent = value;
    if (document.body.dataset.anim === 'off') return;
    el.classList.remove('price-flash');
    void el.offsetWidth; // reflow — animasyonu yeniden başlatmak için
    el.classList.add('price-flash');
  }

  /** Buton durumu: null | 'loading' | 'done' */
  function setButtonState(btn, state) {
    if (!btn) return;
    btn.classList.remove('is-loading', 'is-done');
    if (state) btn.classList.add('is-' + state);
    if (state === 'loading') btn.setAttribute('aria-disabled', 'true');
    else btn.removeAttribute('aria-disabled');
  }

  function toast(message) {
    var root = $('#ToastRoot');
    if (!root) return;
    var el = document.createElement('div');
    el.className = 'toast';
    el.textContent = message;
    root.appendChild(el);
    setTimeout(function () {
      el.remove();
    }, 3200);
  }

  /* --------------------------------------------------- 1. Scroll reveal */

  function initReveal() {
    if (document.body.classList.contains('animations-off')) return;
    var items = $$('.reveal');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    // Aynı ebeveyni paylaşan kardeşlere kademe indeksi ver → sırayla belirsinler
    var seen = new Map();
    items.forEach(function (el) {
      if (el.style.getPropertyValue('--i')) return;
      var parent = el.parentElement;
      var n = seen.get(parent) || 0;
      if (n < 6) el.style.setProperty('--i', n);
      seen.set(parent, n + 1);
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    items.forEach(function (el) {
      io.observe(el);
    });

    // Güvenlik ağı: 4 sn sonra hâlâ gizli kalan varsa zorla göster.
    setTimeout(function () {
      $$('.reveal:not(.is-visible)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add('is-visible');
      });
    }, 4000);
  }

  /* ----------------------------------------------------- 2. Mobil menü */

  function initMenu() {
    var toggle = $('[data-menu-toggle]');
    var nav = $('[data-mobile-nav]');
    if (!toggle || !nav) return;
    on(toggle, 'click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* -------------------------------------------------- 3. Sepet çekmecesi */

  var CartDrawer = {
    el: null,
    lastFocus: null,

    init: function () {
      this.el = $('[data-cart-drawer]');
      if (!this.el) return;
      var self = this;

      document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-cart-open]');
        if (opener) {
          e.preventDefault();
          self.open();
          return;
        }
        if (e.target.closest('[data-cart-close]')) {
          e.preventDefault();
          self.close();
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.el.classList.contains('is-open')) self.close();
      });

      this.bindLines();
    },

    bindLines: function () {
      var self = this;
      if (this._bound) return;
      this._bound = true;

      document.addEventListener('click', function (e) {
        var up = e.target.closest('[data-upsell-add]');
        if (up) {
          e.preventDefault();
          setButtonState(up, 'loading');
          self.change(up.getAttribute('data-line'), parseInt(up.getAttribute('data-target-qty'), 10) || 1);
          return;
        }
        var remove = e.target.closest('[data-line-remove]');
        if (remove) {
          e.preventDefault();
          self.change(remove.getAttribute('data-line'), 0);
          return;
        }
        var step = e.target.closest('[data-qty-step]');
        if (step) {
          e.preventDefault();
          var wrap = step.closest('[data-qty]');
          var input = $('input', wrap);
          var next = parseInt(input.value, 10) + parseInt(step.getAttribute('data-qty-step'), 10);
          if (next < 0) next = 0;
          input.value = next;
          self.change(wrap.getAttribute('data-line'), next);
        }
      });

      document.addEventListener('change', function (e) {
        var input = e.target.closest('[data-qty] input');
        if (!input) return;
        var wrap = input.closest('[data-qty]');
        self.change(wrap.getAttribute('data-line'), parseInt(input.value, 10) || 0);
      });
    },

    open: function () {
      if (!this.el) return;
      this.lastFocus = document.activeElement;
      this.el.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var close = $('[data-cart-close]', this.el);
      if (close) close.focus();
    },

    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      document.body.style.overflow = '';
      if (this.lastFocus) this.lastFocus.focus();
    },

    change: function (line, quantity) {
      var self = this;
      fetch(T.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
      })
        .then(function (r) {
          return r.json();
        })
        .then(function () {
          return self.refresh();
        })
        .catch(function () {
          toast(T.strings ? T.strings.addToCartError : 'Something went wrong');
        });
    },

    refresh: function () {
      var self = this;
      return fetch(window.location.pathname + '?sections=cart-drawer')
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          var html = data['cart-drawer'];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('[data-cart-drawer]', doc);
          var current = $('[data-cart-drawer]');
          if (fresh && current) {
            var wasOpen = current.classList.contains('is-open');
            current.innerHTML = fresh.innerHTML;
            if (wasOpen) current.classList.add('is-open');
            self.el = current;
            self.stagger();
          }
          self.syncCount(doc);
        });
    },

    syncCount: function (doc) {
      var source = $('[data-cart-count]', doc || document);
      var badge = $('header [data-cart-count]');
      if (!badge) return;
      var count = source ? source.getAttribute('data-cart-count') : null;
      if (count === null) return;
      var changed = badge.textContent.trim() !== String(count).trim();
      badge.textContent = count;
      badge.setAttribute('data-cart-count', count);
      badge.hidden = parseInt(count, 10) === 0;
      if (changed && !badge.hidden && document.body.dataset.anim !== 'off') {
        badge.classList.remove('is-bumped');
        void badge.offsetWidth;
        badge.classList.add('is-bumped');
      }
    },

    /** Çekmecedeki satırlara kademe indeksi verir (sırayla kaysınlar) */
    stagger: function () {
      $$('.cart-line', this.el).forEach(function (line, i) {
        line.style.setProperty('--i', Math.min(i, 8));
      });
    }
  };

  /* ------------------------------------------------ 4. Sepete ekleme API */

  function addToCart(items, options) {
    options = options || {};
    return fetch(T.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) throw new Error(body.description || body.message || 'error');
          return body;
        });
      })
      .then(function () {
        if (options.discountCode) {
          window.location.href =
            '/discount/' + encodeURIComponent(options.discountCode) + '?redirect=' + encodeURIComponent(T.routes.cart_url);
          return;
        }
        var mode = options.cartType || 'drawer';
        if (mode === 'checkout') {
          window.location.href = '/checkout';
          return;
        }
        if (mode === 'page') {
          window.location.href = T.routes.cart_url;
          return;
        }
        return CartDrawer.refresh().then(function () {
          CartDrawer.open();
        });
      });
  }

  /* ------------------------------------------------------- 5. Ürün galerisi */

  function initGallery() {
    $$('[data-gallery]').forEach(function (gallery) {
      if (gallery.dataset.ktBound === '1') return;
      gallery.dataset.ktBound = '1';
      var slides = $$('[data-gallery-slide]', gallery);
      var thumbs = $$('[data-gallery-thumb]', gallery);
      var dots = $$('[data-gallery-dot]', gallery);
      if (slides.length < 1) return;
      var index = 0;

      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) {
          s.classList.toggle('is-active', n === index);
        });
        thumbs.forEach(function (t, n) {
          t.classList.toggle('is-active', n === index);
          t.setAttribute('aria-current', n === index ? 'true' : 'false');
        });
        dots.forEach(function (d, n) {
          d.classList.toggle('is-active', n === index);
          d.setAttribute('aria-current', n === index ? 'true' : 'false');
        });
      }

      thumbs.forEach(function (t, n) {
        on(t, 'click', function () {
          show(n);
        });
      });

      dots.forEach(function (d, n) {
        on(d, 'click', function () {
          show(n);
        });
      });

      on($('[data-gallery-prev]', gallery), 'click', function () {
        show(index - 1);
      });
      on($('[data-gallery-next]', gallery), 'click', function () {
        show(index + 1);
      });

      // Dokunmatik kaydırma
      var startX = null;
      var main = $('[data-gallery-main]', gallery);
      on(main, 'touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });
      on(main, 'touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 45) show(dx < 0 ? index + 1 : index - 1);
        startX = null;
      });

      gallery.showMediaById = function (mediaId) {
        var target = slides.findIndex(function (s) {
          return s.getAttribute('data-media-id') === String(mediaId);
        });
        if (target > -1) show(target);
      };

      show(0);
    });
  }

  /* ------------------------------------------------------ 6. Paket seçici */

  function BundleForm(root) {
    var self = this;
    this.root = root;
    this.variants = parseJSON(($('[data-variants-json]', root) || {}).textContent, []) || [];
    this.cartType = root.getAttribute('data-cart-type') || 'drawer';
    this.bundles = $$('[data-bundle]', root);
    this.button = $('[data-atc]', root);
    this.buyNowButton = $('[data-buy-now]', root);
    this.stickyButton = $('[data-sticky-atc-button]');
    this.gallery = $('[data-gallery]', root.closest('.product') || document);

    this.bundles.forEach(function (bundle) {
      on($('input[type="radio"]', bundle), 'change', function () {
        self.select(bundle);
      });
      $$('[data-unit-option]', bundle).forEach(function (control) {
        var evt = control.tagName === 'SELECT' ? 'change' : 'click';
        on(control, evt, function () {
          if (evt === 'click') {
            var group = control.closest('[data-unit]');
            $$('[data-unit-option]', group).forEach(function (b) {
              b.classList.remove('is-active');
              b.setAttribute('aria-checked', 'false');
            });
            control.classList.add('is-active');
            control.setAttribute('aria-checked', 'true');
            var hidden = $('[data-unit-value]', group);
            if (hidden) hidden.value = control.getAttribute('data-variant-id');
            var labelValue = $('[data-unit-label-value]', group);
            if (labelValue) labelValue.textContent = control.getAttribute('data-variant-title') || '';
            var thumb = $('[data-unit-thumb]', group);
            var img = control.getAttribute('data-variant-image');
            if (thumb && img) thumb.src = img;
          }
          self.updatePrices();
        });
      });
    });

    on(this.button, 'click', function (e) {
      e.preventDefault();
      self.submit({ source: self.button });
    });
    on(this.stickyButton, 'click', function (e) {
      e.preventDefault();
      self.submit({ source: self.stickyButton });
    });
    on(this.buyNowButton, 'click', function (e) {
      e.preventDefault();
      self.submit({ checkout: true, source: self.buyNowButton });
    });

    var preselected = this.bundles.filter(function (b) {
      return $('input[type="radio"]', b).checked;
    })[0];
    this.select(preselected || this.bundles[0]);
  }

  BundleForm.prototype.select = function (bundle) {
    if (!bundle) return;
    this.bundles.forEach(function (b) {
      b.classList.toggle('is-selected', b === bundle);
    });
    var radio = $('input[type="radio"]', bundle);
    if (radio) radio.checked = true;
    this.current = bundle;
    this.updatePrices();
  };

  BundleForm.prototype.variantById = function (id) {
    var found = null;
    this.variants.forEach(function (v) {
      if (String(v.id) === String(id)) found = v;
    });
    return found;
  };

  BundleForm.prototype.unitVariantIds = function (bundle) {
    var ids = [];
    $$('[data-unit]', bundle).forEach(function (unit) {
      var hidden = $('[data-unit-value]', unit);
      if (hidden && hidden.value) ids.push(hidden.value);
    });
    if (!ids.length) {
      var qty = parseInt(bundle.getAttribute('data-quantity'), 10) || 1;
      var fallback = bundle.getAttribute('data-default-variant');
      for (var i = 0; i < qty; i++) ids.push(fallback);
    }
    return ids;
  };

  BundleForm.prototype.updatePrices = function () {
    var self = this;
    this.bundles.forEach(function (bundle) {
      var discount = parseFloat(bundle.getAttribute('data-discount')) || 0;
      var fixedDiscount = parseInt(bundle.getAttribute('data-discount-amount'), 10) || 0;
      var ids = self.unitVariantIds(bundle);
      var subtotal = 0;
      var compareTotal = 0;
      ids.forEach(function (id) {
        var v = self.variantById(id);
        if (!v) return;
        subtotal += v.price;
      });
      // Karşılaştırma tabanı BİLEREK indirimsiz toplam: compare_at buraya
      // sızamaz — tasarruf yalnız gerçek paket indirimidir (kurul kararı).
      compareTotal = subtotal;
      // Liquid ile birebir aynı hesap. Sabit tutar (kuruş) girildiyse yüzdenin
      // önüne geçer — gösterilen fiyat Shopify'daki sabit-tutar otomatik
      // indirimle kuruşu kuruşuna eşleşsin diye.
      var total = fixedDiscount > 0
        ? subtotal - fixedDiscount
        : subtotal - Math.floor((subtotal * discount) / 100);
      var qty = parseInt(bundle.getAttribute('data-quantity'), 10) || 1;
      var saving = compareTotal - total;

      setText($('[data-bundle-price]', bundle), formatMoney(total));
      setText($('[data-bundle-unit-price]', bundle), formatMoney(Math.floor(total / qty)));
      var perPieceEl = $('[data-bundle-per-piece]', bundle);
      if (perPieceEl) {
        var units = parseInt(perPieceEl.getAttribute('data-units'), 10) || 0;
        if (units > 0) setText(perPieceEl, formatMoney(Math.floor(total / (qty * units))));
      }

      var compareEl = $('[data-bundle-compare]', bundle);
      if (compareEl) {
        if (compareTotal > total) {
          compareEl.textContent = formatMoney(compareTotal);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      var savingEl = $('[data-bundle-saving]', bundle);
      if (savingEl) {
        if (saving > 0) {
          setText($('[data-bundle-saving-value]', bundle), formatMoney(saving));
          savingEl.hidden = false;
        } else {
          savingEl.hidden = true;
        }
      }

      bundle.setAttribute('data-total', total);
      bundle.setAttribute('data-compare-total', compareTotal);
    });

    if (this.current) {
      var total = parseInt(this.current.getAttribute('data-total'), 10) || 0;
      var compareTotal = parseInt(this.current.getAttribute('data-compare-total'), 10) || 0;
      var saving = compareTotal - total;

      // Sabit alt bar: seçili paketin adı, fiyatı ve üstü çizili tutarı
      setText($('[data-sticky-atc-price]'), formatMoney(total));
      var stickyLabel = $('[data-sticky-atc-label]');
      var tierName = ($('.bundle__qty', this.current) || {}).textContent;
      if (stickyLabel && tierName) stickyLabel.textContent = tierName.trim();

      var stickyCompare = $('[data-sticky-atc-compare]');
      if (stickyCompare) {
        if (saving > 0) {
          stickyCompare.textContent = formatMoney(compareTotal);
          stickyCompare.hidden = false;
        } else {
          stickyCompare.hidden = true;
        }
      }

      // CTA butonlarında canlı toplam (mobilde karar anı netleşir)
      var atcLabelEl = this.button ? $('[data-atc-label]', this.button) : null;
      if (atcLabelEl && this.button.getAttribute('aria-disabled') !== 'true') {
        var baseLabel = this.button.getAttribute('data-label') || 'ADD TO CART';
        atcLabelEl.textContent = baseLabel + ' \u2014 ' + formatMoney(total);
      }
      var stickyLabelBtn = this.stickyButton ? $('.btn__label', this.stickyButton) : null;
      if (stickyLabelBtn) {
        stickyLabelBtn.textContent = 'ADD \u2014 ' + formatMoney(total);
      }

      // Sepete ekle üstündeki tasarruf satırı
      var savingsBox = $('[data-atc-savings]', this.root);
      if (savingsBox) {
        if (saving > 0 && T.strings.savingsLine) {
          savingsBox.textContent = T.strings.savingsLine.replace(
            /__AMOUNT__|\{\{\s*amount\s*\}\}/,
            formatMoney(saving)
          );
          savingsBox.hidden = false;
        } else {
          savingsBox.hidden = true;
        }
      }

      var firstId = this.unitVariantIds(this.current)[0];
      var v = this.variantById(firstId);
      if (v && this.gallery && this.gallery.showMediaById && v.featured_media_id) {
        this.gallery.showMediaById(v.featured_media_id);
      }
      var idInput = $('[data-selected-variant-id]', this.root);
      if (idInput && firstId) idInput.value = firstId;
    }
  };

  BundleForm.prototype.submit = function (opts) {
    var self = this;
    var bundle = this.current;
    if (!bundle) return;
    // Buy It Now: sepete ekleyip doğrudan checkout'a gider
    var targetCartType = opts && opts.checkout ? 'checkout' : this.cartType;

    var counts = {};
    this.unitVariantIds(bundle).forEach(function (id) {
      if (!id) return;
      counts[id] = (counts[id] || 0) + 1;
    });

    var items = Object.keys(counts).map(function (id) {
      return { id: parseInt(id, 10), quantity: counts[id] };
    });

    if (!items.length) {
      toast(T.strings.unavailable);
      return;
    }

    var gifts = parseJSON(bundle.getAttribute('data-gifts'), []) || [];
    gifts.forEach(function (gift) {
      if (!gift.id) return;
      items.push({
        id: parseInt(gift.id, 10),
        quantity: parseInt(gift.quantity, 10) || 1,
        properties: { _hediye: 'true' }
      });
    });

    // Tamamlayıcı ürün kartı boş sepette ana ürünü de aynı istekle ekler
    if (opts && opts.extraItems) {
      opts.extraItems.forEach(function (extra) {
        if (extra && extra.id) items.push(extra);
      });
    }

    var buttons = [this.button, this.stickyButton, this.buyNowButton].filter(Boolean);
    // Çifte gönderim koruması hepsine bakar; animasyon YALNIZ tıklanan butonda
    if (buttons.some(function (b) { return b.classList.contains('is-loading'); })) return;

    var src = (opts && opts.source) || this.button;
    setButtonState(src, 'loading');

    var failed = false;
    addToCart(items, {
      cartType: targetCartType,
      discountCode: bundle.getAttribute('data-discount-code') || ''
    })
      .catch(function (err) {
        failed = true;
        toast(err.message || T.strings.addToCartError);
      })
      .then(function () {
        if (failed) {
          setButtonState(src, null);
          return;
        }
        // Kısa "eklendi" onayı yalnız tıklanan butonda, sonra normale dön
        setButtonState(src, 'done');
        setTimeout(function () {
          setButtonState(src, null);
        }, 1500);
        self.updatePrices();
      });
  };

  function initBundles() {
    $$('[data-bundle-form]').forEach(function (root) {
      // Theme editor bölümü yeniden yüklediğinde iki kez bağlanmayı önler
      if (root.dataset.ktBound === '1') return;
      root.dataset.ktBound = '1';
      root.ktBundleForm = new BundleForm(root);
    });
  }

  /* ----------------------------------- 7. Basit varyant seçici (paketsiz) */

  function initSimpleProductForm() {
    $$('[data-simple-form]').forEach(function (root) {
      if (root.dataset.ktBound === '1') return;
      root.dataset.ktBound = '1';
      var variants = parseJSON(($('[data-variants-json]', root) || {}).textContent, []) || [];
      var cartType = root.getAttribute('data-cart-type') || 'drawer';
      var button = $('[data-atc]', root);
      var buyNowButton = $('[data-buy-now]', root);
      var stickyButton = $('[data-sticky-atc-button]');
      var priceEl = $('[data-price-current]', root);
      var compareEl = $('[data-price-compare]', root);
      // Kasada gerçekten düşen otomatik indirim: sunucuda basılan fiyatı
      // ham varyant fiyatıyla ezmemek için burada da hesaba katılır.
      var promoBox = $('[data-promo-off]', root);
      var promoOff = promoBox ? parseInt(promoBox.getAttribute('data-promo-off'), 10) || 0 : 0;
      var wasEl = $('[data-price-was]', root);
      var idInput = $('[data-selected-variant-id]', root);
      var qtyInput = $('[data-product-quantity]', root);
      var gallery = $('[data-gallery]', root.closest('.product') || document);

      function currentOptions() {
        return $$('fieldset', root).map(function (fs) {
          var checked = $('input:checked', fs);
          return checked ? checked.value : null;
        });
      }

      function match() {
        var opts = currentOptions();
        var found = null;
        variants.forEach(function (v) {
          var ok = true;
          opts.forEach(function (o, i) {
            if (o !== null && v.options[i] !== o) ok = false;
          });
          if (ok && !found) found = v;
        });
        return found;
      }

      // Buton yazısı .btn__label içine yazılır; spinner/onay ikonları korunur
      var buttonLabel = button ? $('[data-atc-label]', button) || button : null;

      function update() {
        var v = match();
        if (!v) {
          if (button) {
            button.setAttribute('aria-disabled', 'true');
            buttonLabel.textContent = T.strings.unavailable;
          }
          return;
        }
        if (idInput) idInput.value = v.id;
        var shownPrice = promoOff > 0 && promoOff < v.price ? v.price - promoOff : v.price;
        setText(priceEl, formatMoney(shownPrice));
        if (wasEl) wasEl.textContent = formatMoney(v.price);
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.textContent = formatMoney(v.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        setText($('[data-sticky-atc-price]'), formatMoney(shownPrice));
        var stickyCompare = $('[data-sticky-atc-compare]');
        if (stickyCompare) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            stickyCompare.textContent = formatMoney(v.compare_at_price);
            stickyCompare.hidden = false;
          } else {
            stickyCompare.hidden = true;
          }
        }
        if (gallery && gallery.showMediaById && v.featured_media_id) gallery.showMediaById(v.featured_media_id);
        if (button) {
          if (v.available) {
            button.removeAttribute('aria-disabled');
            buttonLabel.textContent = button.getAttribute('data-label') || 'ADD TO CART';
          } else {
            button.setAttribute('aria-disabled', 'true');
            buttonLabel.textContent = T.strings.soldOut;
          }
        }
      }

      $$('input[type="radio"]', root).forEach(function (input) {
        on(input, 'change', update);
      });

      function submit(e, opts) {
        e.preventDefault();
        var v = match();
        if (!v || !v.available) return;

        var buttons = [button, stickyButton, buyNowButton].filter(Boolean);
        if (buttons.some(function (b) { return b.classList.contains('is-loading'); })) return;

        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        var src = (opts && opts.source) || button;
        setButtonState(src, 'loading');

        var failed = false;
        addToCart([{ id: v.id, quantity: qty }], { cartType: opts && opts.checkout ? 'checkout' : cartType })
          .catch(function (err) {
            failed = true;
            toast(err.message || T.strings.addToCartError);
          })
          .then(function () {
            if (failed) {
              setButtonState(src, null);
              return;
            }
            setButtonState(src, 'done');
            setTimeout(function () {
              setButtonState(src, null);
            }, 1500);
          });
      }

      on(button, 'click', function (e) { submit(e, { source: button }); });
      on(stickyButton, 'click', function (e) { submit(e, { source: stickyButton }); });
      on(buyNowButton, 'click', function (e) {
        submit(e, { checkout: true, source: buyNowButton });
      });
      update();
    });
  }

  /* ------------------------------------------------- 8. Sabit ATC (mobil) */

  function initStickyAtc() {
    var bar = $('[data-sticky-atc]');
    var anchor = $('[data-atc]');
    if (!bar || !anchor) return;

    /*
      Bar sayfanın altına sabitlendiği için alt bilgideki telif satırını ve
      künyeyi örter. Yüksekliğini ölçüp --sticky-atc-h olarak yayınlıyoruz;
      base.css bunu alt bilginin alt boşluğuna ekliyor. Sabit bir değer
      yazmıyoruz: bar dar ekranda ve fiyat satırı iki satıra kırıldığında
      farklı yükseklikte oluyor. Masaüstünde bar display:none → 0px.
    */
    var setBarHeight = function () {
      var h = bar.offsetHeight || 0;
      document.documentElement.style.setProperty('--sticky-atc-h', h + 'px');
    };
    setBarHeight();
    if ('ResizeObserver' in window) {
      new ResizeObserver(setBarHeight).observe(bar);
    } else {
      window.addEventListener('resize', setBarHeight);
    }

    if (!('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          // Ana buton ekrandayken sabit barı gizle
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    io.observe(anchor);
  }

  function initCollectionSort() {
    var select = $('[data-sort-by]');
    if (!select) return;
    on(select, 'change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ------------------------------------------- 14. Başlık kaydırma durumu */

  function initHeaderScroll() {
    var header = $('.header-wrapper');
    if (!header) return;
    var ticking = false;
    function apply() {
      header.classList.toggle('is-stuck', window.scrollY > 24);
      ticking = false;
    }
    on(
      window,
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(apply);
      },
      { passive: true }
    );
    apply();
  }

  /* ------------------------------------------------ 15. Görsel iskeletleri */

  function initSkeletons() {
    $$('.gallery__main img, .card__media img').forEach(function (img) {
      var holder = img.parentElement;
      if (!holder || holder.classList.contains('skeleton')) return;
      if (img.complete && img.naturalWidth > 0) return;
      holder.classList.add('skeleton');
      function done() {
        holder.classList.add('is-loaded');
      }
      on(img, 'load', done);
      on(img, 'error', done);
    });
  }

  /* ------------------------------------------- 16. Teslimat tarihi tahmini */

  /* --------------------------------------------- 9b. Duyuru mesaj rotasyonu */

  function initAnnouncementRotate() {
    var bar = $('[data-announcement-rotate]');
    if (!bar) return;
    var items = $$('[data-announcement-item]', bar);
    if (items.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  }

  /* ------------------------------------------------ 9c. Hoş geldin popup'ı */

  function initSignupPopup() {
    var pop = $('[data-signup-popup]');
    if (!pop) return;
    var KEY = 'ark_signup_seen';

    /*
      Kayıt başarıyla POST edildiyse sayfa yenilenmiş gelir; localStorage'a
      bakılmaksızın popup BAŞARI haliyle açılır ve WELCOME10 indirim çerezi
      otomatik tanımlanır (müşteri checkout'ta kodu elle yazmak zorunda kalmaz).
    */
    var success = $('[data-signup-success]', pop);
    if (success) {
      var code = success.getAttribute('data-discount-code');
      if (code) {
        fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
      }
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-open'); });
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
      $$('[data-signup-close]', pop).forEach(function (b) {
        on(b, 'click', function () {
          pop.classList.remove('is-open');
          setTimeout(function () { pop.hidden = true; }, 250);
        });
      });
      on(pop, 'click', function (e) {
        if (e.target === pop) {
          pop.classList.remove('is-open');
          setTimeout(function () { pop.hidden = true; }, 250);
        }
      });
      return;
    }

    try {
      if (localStorage.getItem(KEY)) return;
    } catch (e) { return; }
    var delay = parseInt(pop.getAttribute('data-delay'), 10) || 7;
    function dismiss() {
      pop.classList.remove('is-open');
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
      setTimeout(function () { pop.hidden = true; }, 250);
    }
    setTimeout(function () {
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-open'); });
    }, delay * 1000);
    $$('[data-signup-close]', pop).forEach(function (b) { on(b, 'click', dismiss); });
    on(pop, 'click', function (e) { if (e.target === pop) dismiss(); });
    var form = $('form', pop);
    on(form, 'submit', function () {
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
    });
  }

  var TR_MONTHS = ['January', 'February', 'March', 'April', 'May', 'June',
                   'July', 'August', 'September', 'October', 'November', 'December'];


  function initDeliveryEstimate() {
    /*
      Sipariş gününden itibaren TAKVİM günü cinsinden {min}-{max} penceresi
      hesaplanır. Kalıp yalnızca {date_min} içerdiğinde tek tarih gösterilir
      (kullanıcı kararı, 18 Ağu 2026) — bu yüzden "en erken" ifadesi şart:
      kesin teslim vaadi uluslararası kanalda chargeback üretir.
    */
    $$('[data-delivery]').forEach(function (el) {
      var headline = $('[data-delivery-headline]', el);
      if (!headline) return;

      var daysMin = parseInt(el.getAttribute('data-days-min'), 10) || 10;
      var daysMax = parseInt(el.getAttribute('data-days-max'), 10) || 17;
      if (daysMax < daysMin) daysMax = daysMin;

      var now = new Date();
      var from = new Date(now.getTime());
      from.setDate(from.getDate() + daysMin);
      var to = new Date(now.getTime());
      to.setDate(to.getDate() + daysMax);

      function fmt(d) {
        return TR_MONTHS[d.getMonth()] + ' ' + d.getDate();
      }

      var tpl = el.getAttribute('data-template') || 'Arrives as early as {date_min}';
      headline.textContent = tpl.replace('{date_min}', fmt(from)).replace('{date_max}', fmt(to));
    });
  }

  /* ------------------------------------------------- 17. Görsel büyütme */

  function initLightbox() {
    var box = $('[data-lightbox]');
    if (!box) return;
    var img = $('[data-lightbox-img]', box);
    var lastFocus = null;

    function open(src, alt) {
      lastFocus = document.activeElement;
      img.src = src;
      img.alt = alt || '';
      box.hidden = false;
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        box.classList.add('is-open');
      });
      var close = $('[data-lightbox-close]', box);
      if (close) close.focus();
    }

    function close() {
      box.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () {
        box.hidden = true;
        img.src = '';
      }, 220);
      if (lastFocus) lastFocus.focus();
    }

    document.addEventListener('click', function (e) {
      var zoomable = e.target.closest('.gallery__slide.is-active img');
      if (zoomable) {
        open(zoomable.currentSrc || zoomable.src, zoomable.alt);
        return;
      }
      if (e.target.closest('[data-lightbox-close]') || e.target === box) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !box.hidden) close();
    });
  }

  /* ------------------------------------------------ 18. Hızlı sepete ekleme */

  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      if (btn.classList.contains('is-loading')) return;

      var id = parseInt(btn.getAttribute('data-quick-add'), 10);
      if (!id) return;

      var wrap = btn.closest('[data-cart-type]');
      var mode = wrap ? wrap.getAttribute('data-cart-type') : 'drawer';

      setButtonState(btn, 'loading');
      var failed = false;
      addToCart([{ id: id, quantity: 1 }], { cartType: mode })
        .catch(function (err) {
          failed = true;
          toast(err.message || T.strings.addToCartError);
        })
        .then(function () {
          setButtonState(btn, failed ? null : 'done');
          if (!failed) {
            setTimeout(function () {
              setButtonState(btn, null);
            }, 1500);
          }
        });
    });
  }

  /* --------------------------------- 18b. Tamamlayıcı ürün (upsell) ekleme */

  function initAddonAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-addon-add]');
      if (!btn) return;
      e.preventDefault();
      if (btn.classList.contains('is-loading')) return;

      var id = parseInt(btn.getAttribute('data-addon-add'), 10);
      if (!id) return;

      var wrap = btn.closest('[data-cart-type]');
      var mode = wrap ? wrap.getAttribute('data-cart-type') : 'drawer';
      var formRoot = btn.closest('[data-bundle-form]');
      var form = formRoot ? formRoot.ktBundleForm : null;

      setButtonState(btn, 'loading');

      // Sepet boşsa ana ürünü de seçili paket adediyle ekle; doluysa
      // müşteri ana ürünü zaten seçmiş demektir, sadece ek ürünü ekle.
      fetch(T.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { item_count: 1 }; })
        .catch(function () { return { item_count: 1 }; })
        .then(function (cart) {
          if (cart && cart.item_count === 0 && form && form.current) {
            form.submit({ source: btn, extraItems: [{ id: id, quantity: 1 }] });
            return;
          }
          var failed = false;
          return addToCart([{ id: id, quantity: 1 }], { cartType: mode })
            .catch(function (err) {
              failed = true;
              toast(err.message || T.strings.addToCartError);
            })
            .then(function () {
              setButtonState(btn, failed ? null : 'done');
              if (!failed) {
                setTimeout(function () { setButtonState(btn, null); }, 1500);
              }
            });
        });
    });
  }

  function initVideoRow() {
    $$('[data-video-row]').forEach(function (row) {
      if (row.dataset.ktBound === '1') return;
      row.dataset.ktBound = '1';

      var track = $('[data-video-track]', row);
      var slides = $$('[data-video-slide]', row);
      var dots = $$('[data-video-dot]', row);
      var prev = $('[data-video-prev]', row);
      var next = $('[data-video-next]', row);
      if (!track || slides.length < 1) return;

      function current() {
        // Kaydırma konumundan aktif kartı bul
        var i = Math.round(track.scrollLeft / (slides[0].offsetWidth + gap()));
        return Math.max(0, Math.min(slides.length - 1, i));
      }

      function gap() {
        var g = parseFloat(getComputedStyle(track).columnGap);
        return isNaN(g) ? 0 : g;
      }

      function goTo(i) {
        // Döngüsel: sondan sonra başa, baştan geriye sona
        var n = slides.length;
        i = ((i % n) + n) % n;
        track.scrollTo({ left: i * (slides[0].offsetWidth + gap()), behavior: 'smooth' });
      }

      function sync() {
        var i = current();
        dots.forEach(function (d, n) {
          d.classList.toggle('is-active', n === i);
          d.setAttribute('aria-current', n === i ? 'true' : 'false');
        });
        // Döngüsel olduğu için oklar hiç pasifleşmez
      }

      on(prev, 'click', function () { goTo(current() - 1); });
      on(next, 'click', function () { goTo(current() + 1); });
      dots.forEach(function (d, n) {
        on(d, 'click', function () { goTo(n); });
      });

      var ticking = false;
      on(track, 'scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          sync();
          ticking = false;
        });
      }, { passive: true });

      sync();

      // Ekranda olmayan videoyu durdur — veri ve pil harcamasın
      var videos = $$('video', row);
      if (!videos.length) return;

      var autoplay = row.getAttribute('data-autoplay') === 'true';

      if (!('IntersectionObserver' in window)) return;

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            if (entry.isIntersecting) {
              if (autoplay && v.paused) {
                var p = v.play();
                if (p && p.catch) p.catch(function () {});
              }
            } else if (!v.paused) {
              v.pause();
            }
          });
        },
        { threshold: 0.5 }
      );
      videos.forEach(function (v) {
        v.muted = true;
        v.setAttribute('playsinline', '');
        io.observe(v);
      });
    });
  }

  /* ------------------------------------------------------------- başlat */

  function init() {
    initReveal();
    initMenu();
    CartDrawer.init();
    initGallery();
    initBundles();
    initSimpleProductForm();
    initStickyAtc();
    initAnnouncementRotate();
    initSignupPopup();
    initCollectionSort();
    initHeaderScroll();
    initSkeletons();
    initDeliveryEstimate();
    initLightbox();
    initQuickAdd();
    initAddonAdd();
    initVideoRow();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor uyumu
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);

  window.ArkhelaisTheme.formatMoney = formatMoney;
  window.ArkhelaisTheme.addToCart = addToCart;
  window.ArkhelaisTheme.CartDrawer = CartDrawer;
  window.ArkhelaisTheme.toast = toast;
})();
